// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.create-knowledge-modal-iVmUSo .semi-modal-content{max-height:calc(100vh - 100px)!important}.import-unit-type-label-LGpAUq{margin-bottom:8px;font-size:14px;font-weight:700;line-height:20px;display:block}.create-form-Mrkhfb .semi-form-field{padding-top:0;padding-bottom:24px!important}.create-form-Mrkhfb .semi-form-field-label{color:var(--coz-fg-secondary);margin-bottom:0;padding:0 8px 6px;font-size:12px;font-style:normal;font-weight:500;line-height:16px}.upload-avatar-container-j8V0QP{width:auto}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"create-knowledge-modal": `create-knowledge-modal-iVmUSo`,
	"createKnowledgeModal": `create-knowledge-modal-iVmUSo`,
	"import-unit-type-label": `import-unit-type-label-LGpAUq`,
	"importUnitTypeLabel": `import-unit-type-label-LGpAUq`,
	"create-form": `create-form-Mrkhfb`,
	"createForm": `create-form-Mrkhfb`,
	"upload-avatar-container": `upload-avatar-container-j8V0QP`,
	"uploadAvatarContainer": `upload-avatar-container-j8V0QP`
};
export default ___CSS_LOADER_EXPORT___;
